import React from "react";

export const Imagen = ({ imgUrl, onClick }) => {
  return <img src={imgUrl} className="logoCliente" onClick={onClick} />;
};
